import PageLang from "../../utils/page-lang";
import Popup from "../../utils/popup";
import DetectMobileBrowsers from "../../utils/detect-mobile-browsers";

class PopupUsunieciePozycjiZKoszyka {
  constructor() {
    this.popupModal = $("#popup-modal");
    this.trash = ".js-shopping-cart-alert-remove-trash";
    this.removeBtnTrue = ".js-shopping-cart-alert-remove-true";
    this.removedItemUrl = null;
    this.translates = {
      czy_usunac: {
        pl: "Czy na pewno chcesz usunąć tę pozycje z koszyka?",
        en: "Are you sure you want to delete this item from the cart?"
      },
      tak: {
        pl: "Tak",
        en: "Yes"
      },
      nie: {
        pl: "Nie",
        en: "No"
      }
    };
    this.popup = new Popup(this.getHTML(), this.trash);
  }

  events() {
    const _this = this;

    $(document).on("click", this.trash, function(event) {
      event.preventDefault();

      _this.getRemovedItemUrl($(this));
    });

    $(document).on("click", this.removeBtnTrue, function(event) {
      event.preventDefault();

      _this.removeItem($(this));
    });

    _this.popupModal.on("hidden.bs.modal", function() {
      _this.removedItemUrl = null;
    });
  }

  getHTML() {
    const isMobileBrowser = DetectMobileBrowsers.check();

    if (isMobileBrowser) {
      return `<p class="fr-popup__text">${
        this.translates.czy_usunac[PageLang.get()]
      }</p>
              <div class="form__section form__section--last">
                <div class="form__btns">
                  <a href="#" class="form__btn js-shopping-cart-alert-remove-true">${
                    this.translates.tak[PageLang.get()]
                  }</a>
                  <a href="#" class="form__btn form__btn--white js-shopping-cart-alert-remove-false" data-dismiss="modal">${
                    this.translates.nie[PageLang.get()]
                  }</a>
                </div>
              </div>`;
    } else {
      return `<p class="fr-popup__text">${
        this.translates.czy_usunac[PageLang.get()]
      }</p><div class="form__section form__section--last">
                <div class="form__btns">
                    <a href="#" class="form__btn--half-popup btn btn--large btn--brown js-shopping-cart-alert-remove-true">${
                      this.translates.tak[PageLang.get()]
                    }</a>
                    <a href="#" class="form__btn--half-popup btn btn--large btn--white js-shopping-cart-alert-remove-false" data-dismiss="modal">${
                      this.translates.nie[PageLang.get()]
                    }</a>
                </div>
            </div>`;
    }
  }

  getRemovedItemUrl(removedItem) {
    this.removedItemUrl = removedItem.attr("href");
  }

  removeItem() {
    window.location = this.removedItemUrl;
    this.popup.hidePopup();
  }

  init() {
    this.events();
  }
}

export default PopupUsunieciePozycjiZKoszyka;
